import db from '@mobile/db/db';
import TodoService from '@mobile/services/todo';
import { eventBus } from '@/eventBus';
import { now } from '@/util/UnixTimestamps';

const storeName = 'todos';

export default {

    async get(key) {
        await db.open();
        return await db.get(storeName, key);
    },

    async put(todo) {
        await db.open();
        return await db.put(storeName, todo);
    },

    async getAll() {
        await db.open();
        const result = await db.getAll(storeName);
        result.sort(({ due_at: a }, { due_at: b }) => {
            if (a === b) {
                return 0;
            }
            // nulls sort before anything else
            if (a === null) {
                return -1;
            }
            if (b === null) {
                return 1;
            }
            // otherwise, if we're ascending, lowest sorts first
            return a < b ? -1 : 1;
        });
        return result;
    },

    async update(id) {
        const todo = await TodoService.get(id);
        if (todo) {
            todo.checked_at = now();
            await db.put(storeName, todo);
        }
    },

    async updateAll() {
        const todos = await TodoService.getAll();
        if (!todos) return;

        await db.open();
        const currentTodoKeys = await db.getAllKeys(storeName);

        await Promise.all(
            currentTodoKeys.map(
                (id) => (!todos.find((todo) => todo.id === id)) && db.delete(storeName, id),
            ),
        );

        const updateLocalTodo = (todo) => db.put(storeName, {
            ...todo,
            checked_at: now(),
        });

        const total = Object.keys(todos).length;

        for (const i in todos) {
            const todo = todos[i];
            const localTodo = await this.get(todo.id);

            const shouldFetchUpdatedTodo = !localTodo || todo.updated_at > localTodo.updated_at;
            if (shouldFetchUpdatedTodo) {
                const updatedTodo = await TodoService.get(todo.id);
                await updateLocalTodo(updatedTodo);
            } else if (localTodo) {
                await updateLocalTodo(localTodo);
            }
            eventBus.$emit('downloadProgress', { total, loaded: (parseInt(i, 10) + 1) });
        }

        eventBus.$emit('fetchedAllTodos');
    },
};
